/* ============================================================================
   Inteligência Educacional — caminho da seção.
   ============================================================================
   A rota e o item de menu vêm do cadastro do backend (configuration_links,
   configuration_menus, access_roles_menus e access_roles_links), como as
   demais telas do AVA. Quem abre cada perfil do painel é decidido dentro da
   seção, pelo papel ativo (pages/InteligenciaEducacional/config/perfilPorRole.js).

   O path precisa bater com o `path` cadastrado em configuration_links, e o
   link precisa de `exact = false`: as sub-rotas /professor, /admin e /gestor
   são resolvidas em pages/InteligenciaEducacional/App.jsx.
   ========================================================================== */

export const IE_PATH = "/inteligencia-educacional";
